import { ChangeDetectorRef, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from 'rxjs';

interface LoaderConfig {
  isLoading: boolean;
  type: 'full' | 'small' | 'inline';
  dismissible?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingType: 'full' | 'small' | 'inline' = 'full';
  private loadingSubject: BehaviorSubject<LoaderConfig> =
    new BehaviorSubject<LoaderConfig>({
      isLoading: false,
      type: this.loadingType,
      dismissible: false,
    });

  public loading$: Observable<LoaderConfig> = this.loadingSubject.asObservable();

  show(type: 'full' | 'small' | 'inline' = 'full', dismissible: boolean = false) {
    this.loadingType = type;
    this.loadingSubject.next({ isLoading: true, type: this.loadingType, dismissible });
  }

  hide(delayInMs?: number) {
    // Delay the hide to allow for a smoother transition
    const delayInterval = delayInMs ?? (this.loadingType === 'inline' ? 400 : 800);
    setTimeout(() => {
      this.loadingSubject.next({
        isLoading: false,
        type: this.loadingType,
        dismissible: false,
      });
    },delayInterval)
  }
}
